import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import { useUnits } from "../../utils/hooks";

const Period = [
  {
    value: "",
    label: "Select Period",
  },
  {
    value: "days",
    label: "Days",
  },
  {
    value: "months",
    label: "Months",
  },
  {
    value: "years",
    label: "Years",
  },
];

export const OutputSettingsSections = ({
  item,
  index,
  formik,
  arrayHelpers,
  isFirst,
  BOM,
  reFreshBill,
}) => {
  const { Units } = useUnits();

  const DisplayErrors = (name) => {
    const error = formik.errors?.items?.[index]?.[name];

    const touched = formik.touched?.items?.[index]?.[name];

    return touched && error ? (
      <p className="custom-invalid-feedback">{error}</p>
    ) : null;
  };

  const selectedBOMs = formik.values?.items?.map((el) => el?.BOM) || [];

  const selectedSet = new Set(selectedBOMs);

  const availableBOMs = BOM.filter(({ value }) => !selectedSet.has(value));

  return (
    <div key={index} className="border rounded p-3 mb-4">
      <div className="d-flex justify-content-between mb-3">
        <h5>Output #{index + 1}</h5>

        {formik.values.items.length > 1 && (
          <Button
            variant="danger"
            size="sm"
            onClick={() => arrayHelpers.remove(index)}
          >
            Remove
          </Button>
        )}
      </div>

      <div className="row">
        <Form.Group className="col-6 mb-3">
          <Form.Label className="mb-1">Name</Form.Label>
          <Form.Control
            placeholder="Enter Name"
            value={item.name}
            name={`items.${index}.name`}
            onChange={formik.handleChange}
          />
          {DisplayErrors("name")}
        </Form.Group>

        <Form.Group className="col-6 mb-3">
          <Form.Label className="mb-1">Select Bill of Materials</Form.Label>
          <Select
            classNamePrefix={"form-select"}
            isSearchable={true}
            name="BOM"
            value={BOM.find((el) => el.value === item.BOM)}
            onChange={({ value, fromConversion }) => {
              formik.setFieldValue(`items.${index}.BOM`, value);
              formik.setFieldValue(
                `items.${index}.fromConversion`,
                fromConversion,
              );
            }}
            options={availableBOMs}
          />

          {DisplayErrors("BOM")}
        </Form.Group>

        {/* Unit */}

        <Form.Group className="col-6 mb-3">
          <Form.Label className="mb-1">Unit</Form.Label>
          <Select
            classNamePrefix={"form-select"}
            isSearchable={true}
            value={Units.find((el) => el.value === item.unit)}
            onChange={({ value, label }) => {
              formik.setFieldValue(`items.${index}.unit`, value);
            }}
            options={Units}
          />

          {DisplayErrors("unit")}
        </Form.Group>

        <Form.Group className="col-6 mb-3">
          <Form.Label className="mb-1">Unit Value</Form.Label>
          <Form.Control
            placeholder="Enter Unit Value"
            value={item.unitValue}
            name={`items.${index}.unitValue`}
            onChange={formik.handleChange}
          />
          {DisplayErrors("unitValue")}
        </Form.Group>

        {/* Period */}
        <Form.Group className="col-6 mb-3">
          <Form.Label className="mb-1">Period</Form.Label>
          <Select
            classNamePrefix={"form-select"}
            isSearchable={true}
            value={Period.find((el) => el.value === item.period)}
            onChange={({ value, label }) => {
              formik.setFieldValue(`items.${index}.period`, value);
            }}
            options={Period}
          />
          {DisplayErrors("period")}
        </Form.Group>
        <Form.Group className="col-6 mb-3">
          <Form.Label className="mb-1">Period Time</Form.Label>
          <Form.Control
            placeholder="Enter Period Time"
            value={item.periodTime}
            name={`items.${index}.periodTime`}
            onChange={formik.handleChange}
          />
          {DisplayErrors("periodTime")}
        </Form.Group>
        <Form.Label className="col-md-5 mb-3">
          <Form.Label className="fw-5 mb-3">
            Stop When Target Is Reached
          </Form.Label>
          <Form.Switch
            type="switch"
            className="custom-form-check"
            label="Auto Stop"
            checked={item.stopAtTarget}
            onChange={() => {
              formik.setFieldValue(
                `items.${index}.stopAtTarget`,
                !item.stopAtTarget,
              );
            }}
          />
        </Form.Label>
      </div>
    </div>
  );
};
